import { Component } from '@angular/core'
import { ICON_TYPE } from '@spartacus/storefront'

@Component({
    selector: 'eb-rfp-form-number-hint',
    templateUrl: './eb-rfp-form-number-hint.component.html',
    styleUrls: ['./eb-rfp-form-number-hint.component.scss'],
    standalone: false
})
export class EbRfpFormNumberHintComponent {
  iconType = ICON_TYPE.INFO
}
